import { useContext } from 'react'
import styled from '@emotion/styled'
import { Flex, Box } from 'rebass'
import ReactTooltip from 'react-tooltip'
import { useFetch } from '../../hooks/useFetch'
import { DataContext } from '../../contexts/dataContext'

import { MediaQueries as Mq } from '../../styles/settings/theme'
import { FaPlay } from 'react-icons/fa'
import { lang } from '../../utils/lang'

const Video = styled(Flex)`
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 172px;
  background-color: rgba(0, 0, 0, 0.5);

  cursor: pointer;
  margin: 0.5rem;
  .tooltip-video {
    width: 240px;
  }

  ${Mq.sm} {
    width: 45%;
    // min-width: 300px;
    margin: 0.5rem;
  }
`
const VideoBox = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(172px - 2.25rem);
`
const VideoImg = styled.img`
  position: absolute;
  top: 0;
  height: calc(172px - 2.25rem);
  width: 100%;
  object-fit: cover;
`
const VideoTitle = styled(Flex)`
  width: 100%;
  height: 2.25rem;
  background-color: ${(props) => props.theme.colors.black};
  color: ${(props) => props.theme.colors.white};
  font-size: 0.75rem;
  align-items: center;
  padding: 0 1rem;
  line-height: 1.2;
`
const Circle = styled(Flex)`
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.red};
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  z-index: 10;
`

const VideoFetcher = ({ url }) => {
  const { ui } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  //get video thumbnail
  const {
    data: videoData,
    loading,
    error
  } = useFetch(
    `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`
  )

  return (
    <Video>
      {loading ? (
        <p dir={dir}>{lang[ui]['Loading']}</p>
      ) : error ? (
        <p dir={dir}>{ui === 'en' ? error : lang[ui]['Error']}</p>
      ) : (
        <>
          <a href={`${url}`} target="_blank" rel="noreferrer">
            <VideoBox>
              <VideoImg alt={videoData?.title} src={videoData?.thumbnail_url} />
              <Circle>
                <FaPlay color="white" size="14" />
              </Circle>
            </VideoBox>
          </a>
          <ReactTooltip
            place={'top'}
            type={'light'}
            //arrowColor={'transparent'}
            effect={'solid'}
            className="tooltip-video"
          />
          <VideoTitle data-tip={videoData?.description}>
            {videoData?.title}
          </VideoTitle>
        </>
      )}
    </Video>
  )
}

export default VideoFetcher
